export const SET_USER_TIMEZONE_START = 'SET_TIMEZONE_START';
export const SET_USER_TIMEZONE_SUCCESS = 'SET_TIMEZONE_SUCCESS';
export const SET_USER_TIMEZONE_FAIL = 'SET_TIMEZONE_FAIL';

export const GET_USER_TIMEZONE_START = 'GET_TIMEZONE_START';
export const GET_USER_TIMEZONE_SUCCESS = 'GET_TIMEZONE_SUCCESS';
export const GET_USER_TIMEZONE_FAIL = 'GET_TIMEZONE_FAIL';
